function activateVideo(video, uid) {
	var el = document.getElementById('vid-'+video+'-uid'+uid);
	el.innerHTML = '<div class="yt_video"><iframe src="https://www.youtube-nocookie.com/embed/'+video+'?rel=0&autoplay=1&showinfo=0&cc_load_policy=1&wmode=transparent" allow="autoplay" allowfullscreen></iframe></div>';
}
